export { webAttributionPlugin } from './web-attribution';
export { webAttributionPlugin as plugin } from './web-attribution';
export * as Types from './typings/web-attribution';
